import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'


@Injectable({
  providedIn: 'root'
})
export class UtilitaryService {
  droits: any
  constructor(
    private http: HttpClient
  ) {
  }
  log(...args) {
    if (!environment.production) {
      console.log(...args)
    }
  }
}